import { InlineLoader } from "./Loaders";

const getReadableBackupTime = (backupName = "") => {
  const timestamp = Number(`${backupName}`.replace("vi-bak-", ""));
  if (!timestamp) {
    return "";
  }

  return new Date(timestamp).toLocaleString();
};

const BackupRestoreModal = ({
  backups,
  loading,
  error,
  onSelect,
  onCancel,
}) => {
  return (
    <div className="web-modalOverlay">
      <div className="backup-modalCard">
        <h2 className="backup-modalTitle">Select Backup to Restore</h2>
        <p className="backup-modalCopy">
          Restore a desktop backup into the web budget database when desktop
          changes need to be brought into the web portal.
        </p>

        <div className="backup-modalWarning">
          This is optional. The web budget module uses saved database data
          unless you explicitly restore a desktop backup.
        </div>

        {error ? <div className="web-inlineError">{error}</div> : null}

        <div className="backup-modalList">
          {backups.map((item) => (
            <button
              type="button"
              className="backup-option"
              key={`${item.latestBackupPath}-${item.latestBackup}`}
              disabled={loading}
              onClick={() => onSelect(item)}
            >
              <strong>{item.device || "Desktop backup"}</strong>
              <span>{item.latestBackup}</span>
              <small>{getReadableBackupTime(item.latestBackup)}</small>
            </button>
          ))}
        </div>

        {loading ? (
          <p className="web-inlineInfo">
            <InlineLoader label="Restoring backup..." />
          </p>
        ) : null}

        {onCancel ? (
          <div className="backup-modalActions">
            <button
              type="button"
              className="landingPage-discardBtn"
              disabled={loading}
              onClick={onCancel}
            >
              Continue without Restore
            </button>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default BackupRestoreModal;
